import '@cloudscape-design/global-styles/index.css';
import './styles/cloudscape-tokens.scss';
import './global.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { detectDevice, DEVICE_MOBILE } from './v2/platform/detectDevice';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}
const root = createRoot(container);

// Mobile v2 app activates when:
//   1. Running in local development on a mobile device, OR
//   2. The URL contains ?v2=mobile (any environment, including gamma/prod)
const isDev = process.env.NODE_ENV !== 'production';
const hasV2Param = new URLSearchParams(window.location.search).get('v2') === 'mobile';
const isMobileV2 = hasV2Param || (isDev && detectDevice() === DEVICE_MOBILE);

if (isMobileV2) {
  import('./v2/Root').then(({ Root }) => {
    root.render(
      <React.StrictMode>
        <Root />
      </React.StrictMode>,
    );
  });
} else {
  const { default: App } = require('./App');
  const { FeatureFlagsProvider } = require('./context/FeatureFlagsContext');
  const { initializeRum } = require('./rum');

  initializeRum();
  root.render(
    <React.StrictMode>
      <FeatureFlagsProvider>
        <App />
      </FeatureFlagsProvider>
    </React.StrictMode>,
  );
}
